import { createJSONStorage } from 'jotai/utils';

export const makeJotaiSessionStorage = () =>
  createJSONStorage(() =>
    typeof window !== 'undefined' ? window.sessionStorage : (undefined as unknown as Storage)
  );
